import React, { useState, useEffect, useContext } from 'react'
import Wrapper from '../../../components/common/Wrapper/Wrapper';
import organisms from '../../../components/organisms';
import { ShowActiveTab } from '../../../Context';
import molecules from '../../../components/molecules';
import service from '../../../api/services';
import { Default_Page_Limit } from '../../../constants/defaultValues'
import { useToasts } from 'react-toast-notifications';
import DeliverForm from './DeliverForm';
import { TBarcodeListRes, TDeliverProduct, TDropdown } from './interface';

const { TransferRequest } = organisms
const { TopBar, CreateModal } = molecules

const Index = () => {
    const { addToast } = useToasts();
    const [productList, setProductList] = useState<[] | undefined>();
    const [limitPerPage, setLimitPerPage] = useState<number>(Default_Page_Limit);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [search, setSearch] = useState<string | undefined>();
    const [isContactLensProduct, setIsContactLensProduct] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false)
    const [barcodeList,setBarcodeList] = useState<TDropdown[]>([]);
    const [deliverProduct, setDeliverProduct] = useState<TDeliverProduct>({
            inventory_item_id:'',
            procurement_item_id: ''
    })

    const { setActiveTab }: any = useContext(ShowActiveTab)

    const getBarcodeOption=(response:TBarcodeListRes[]):TDropdown[]=>{
        if(!response) return []
        return response?.map((item) => ({
            label: item.bar_code,
            value: item.id,
            store_ownership: item.store_ownership,
          }));
    }


    const list = async () => {
        try {
            const response = await service.transferRequestService.list({ "page": currentPage, "search": search, "limit": limitPerPage, "status": '', is_contact_lens: isContactLensProduct })
            if (response.status === 200) {
                setProductList(response?.data)
            }
        } catch (error: any) {
            console.error(error)
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    const getBarcodeList= async(id:string)=>{
        const payload={
            product_id:id
        }
        try {
            const response = await service?.transferRequestService?.getAvailableBarcodes(payload);
            if(response?.status === 200 || response?.status === 201){
                setShowModal(!showModal);   
                setBarcodeList(getBarcodeOption(response?.data?.data))
            }
        } catch (error) {
            console.error("error>>>>,error")
        }
    }

    const _handleEdit = (id: string, productId:string) => {
        setDeliverProduct((prevState)=>({...prevState,procurement_item_id:id }))
        getBarcodeList(productId)
    }

    const handleSubmit=async()=>{
        if(!deliverProduct?.inventory_item_id || !deliverProduct?.procurement_item_id) return ;

        try {
            const response = await service?.transferRequestService?.markAsDelivered(deliverProduct);
            if(response?.status === 200 || response?.status === 201){
                _handleClose();
                list()
                addToast(response?.data?.message, {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
        } catch (error:any) {
            console.error("error>>>",error);
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
        setShowModal(!showModal)
    }

    const handleChange=(value:TDropdown)=>{
        if(!value) return;
        setDeliverProduct((prevState)=>({...prevState,inventory_item_id:value?.value }));
    }

    const _handleClose=()=>{
        setDeliverProduct({
            inventory_item_id:'',
            procurement_item_id: ''
        });
        setBarcodeList([]);
        setShowModal(!showModal);
    }

    useEffect(() => {
        setActiveTab("transferRequest")
        list()
    }, [search, isContactLensProduct])

    return (
        <Wrapper>
            <div className='row align-items-center'>
                <TopBar heading='Transfer Request' />
            </div>
            <TransferRequest
                productList={productList}
                setSearch={setSearch}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                setLimitPerPage={setLimitPerPage}
                limit={limitPerPage}
                isContactLensProduct={isContactLensProduct}
                setIsContactLensProduct={setIsContactLensProduct}
                _handleEdit={(id: string,productId:string) => _handleEdit(id,productId)}
            />
           {showModal && <CreateModal
                show={showModal}
                header={'Store'}
                onHide={() => _handleClose()}
                submitBtnText={'Deliver'}
                handleSubmit={handleSubmit}
            >
                <DeliverForm
                barcodeList={barcodeList}
                handleChange={(value:TDropdown)=>handleChange(value)}
                />
            </CreateModal>}

        </Wrapper>
    )
}
export default Index
